const DEFAULT_LANG = 'pt';
const LANG_STORAGE_KEY = 'lang';

function hasStorage() {
  try {
    return typeof window !== 'undefined' && window.localStorage;
  } catch (error) {
    return false;
  }
}

function normalizeLang(value) {
  if (!value || typeof value !== 'string') {
    return DEFAULT_LANG;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return DEFAULT_LANG;
  }

  const normalized = trimmed.toLowerCase();
  if (normalized === 'pt-br' || normalized === 'pt_br') {
    return 'pt';
  }

  return normalized;
}

export function getCurrentLang() {
  if (!hasStorage()) {
    return DEFAULT_LANG;
  }
  const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
  const normalized = normalizeLang(stored);
  if (!stored || stored !== normalized) {
    window.localStorage.setItem(LANG_STORAGE_KEY, normalized);
  }
  return normalized;
}

export function setCurrentLang(lang) {
  const normalized = normalizeLang(lang);
  if (hasStorage()) {
    window.localStorage.setItem(LANG_STORAGE_KEY, normalized);
  }
  return normalized;
}

export function syncLangWithBackend(httpClient, lang = getCurrentLang()) {
  if (!httpClient) {
    return Promise.resolve();
  }
  const normalized = normalizeLang(lang);
  return httpClient({
    method: 'get',
    url: 'replaceLang',
    data: { lang: normalized },
  }).catch((error) => {
    console.warn('syncLangWithBackend failed', error);
  });
}

export { DEFAULT_LANG, LANG_STORAGE_KEY };